import { apiService } from './api';
import type {
  LearnerTourDto,
  PublicLearnerTourDto,
  UpsertLearnerTourDto,
} from '../types/learnerTour';

class LearnerTourService {
  async getAllTours(): Promise<LearnerTourDto[]> {
    const response = await apiService.get<unknown>('/api/Admin/learner-tours', { cache: false });
    if (Array.isArray(response)) return response;
    if (response && typeof response === 'object' && Array.isArray((response as { data?: unknown }).data)) {
      return (response as { data: LearnerTourDto[] }).data;
    }
    return [];
  }

  async getTourByPageKey(pageKey: string): Promise<LearnerTourDto | null> {
    try {
      return await apiService.get<LearnerTourDto>(
        `/api/Admin/learner-tours/by-page/${encodeURIComponent(pageKey)}`
      );
    } catch {
      return null;
    }
  }

  async upsertTour(dto: UpsertLearnerTourDto): Promise<LearnerTourDto> {
    return apiService.put<LearnerTourDto>('/api/Admin/learner-tours', dto);
  }

  async deleteTour(id: number): Promise<void> {
    await apiService.delete(`/api/Admin/learner-tours/${id}`);
  }

  async getPublicTour(pageKey: string, locale: string): Promise<PublicLearnerTourDto | null> {
    try {
      return await apiService.get<PublicLearnerTourDto>(
        `/api/Content/learner-tours/${encodeURIComponent(pageKey)}?locale=${encodeURIComponent(locale)}`
      );
    } catch {
      return null;
    }
  }
}

export const learnerTourService = new LearnerTourService();
